import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap"
import { VIPFieldConfig, SyncFieldItemType, SyncFieldSectionType, getAllCheckedFields } from "../VIPFieldConfig";
import { useAppSelector } from "../../../redux/hooks";
import { lddGlobalSessionInfo } from "../../navigationTypes";
import { FileSyncInfoType } from "../notificationsTypes";


type MatchFoundModalProps = {
    show: boolean,
    fileInfo: FileSyncInfoType,
    handleClose,
    handleConfirm: (msgID: string, mergeParts: string, appID: string) => void,
}


const SyncFieldsModal = ({
    show,
    fileInfo,
    handleClose,
    handleConfirm,
}: MatchFoundModalProps) => {
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((g) => g.SessionInfo);
    let appCode = "RPRPW";
    if (SESSION_INFO.appProvinceShort === "BC") {
        appCode = "CPBC";
    } else if (fileInfo.srcApp > "" && fileInfo.srcApp.includes("RPWCP")) {
        appCode = "CPON"
    }
    const fields: Set<string> = new Set(getAllCheckedFields(VIPFieldConfig[appCode]));
    const fieldsBy2: Array<SyncFieldSectionType[]> = reduceBy2(VIPFieldConfig[appCode]);

    /**
     * Converts an 1d array to 2d, e.g. [1, 2, 3] => [[1, 2], [3]]
     * @returns a new 2d array
     */
    function reduceBy2<T>(items: Array<T>): Array<Array<T>> {
        return items.reduce((resultArray: Array<Array<T>>, item: T, index: number) => { 
        const chunkIndex = Math.floor(index / 2);
        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
        }
        resultArray[chunkIndex].push(item);
        return resultArray;
      }, []);
    }

    function handleFormChange(e) {
        e.target.checked ? fields.add(e.target.id) : fields.delete(e.target.id);
    }

    const buildFieldSection = (sec: SyncFieldSectionType, key: string) => {
        return <Col xs={6} key={`field-col-${key}`}>
            <h3>{sec.label}</h3>
            {sec.subItems.map((item: SyncFieldItemType, idx) => {
                return <Form.Check type="checkbox"
                            label={item.label}
                            id={item.id ?? item.label}
                            defaultChecked={item.defaultChecked}
                            disabled={item.disabled}
                            key={`field-form-${key}-${idx}`} />
            })}
        </Col>
    }

    return (
        <Modal centered show={show}>
            <Modal.Header>
                <Modal.Title>Sync to File</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="primary">Select which information you would like to sync to your file.</Alert>
                <Alert variant="warning">Existing information in your file will be overwritten.</Alert>
                <Form.Group className="mb-3 mt-3" onChange={(e) => {handleFormChange(e)}}>
                    {fieldsBy2.map((secs: SyncFieldSectionType[], row_idx) => {
                        return  <Row className="mb-4" key={`field-row-${row_idx}`}>
                                    {secs.map((sec: SyncFieldSectionType, col_idx) => {
                                        return buildFieldSection(sec, `${row_idx}-${col_idx}`);
                                    })}
                                </Row>
                    })}
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <>
                    <Button variant="text" onClick={handleClose} style={{left: 0, paddingLeft: "20px", position: "absolute"}}>Cancel</Button>
                    <Button variant="primary" onClick={() => handleConfirm(fileInfo.msgID, Array.from(fields).join(" "), fileInfo.appID)}>Confirm</Button>
                </>
            </Modal.Footer>
        </Modal>
    );
}

export default SyncFieldsModal;